import { useMutation } from '@tanstack/react-query'
import { initiateCustomersRewardsWithdrawal } from 'services/RewardsService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { type CustomersEarningsWithdrawalRequest } from 'types/rewards'

export const useInitiateCustomersRewardsWithdrawalMutation = () =>
  useMutation<void, BaseErrorResponse, CustomersEarningsWithdrawalRequest>({
    mutationFn: initiateCustomersRewardsWithdrawal,
  })
